import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import API from "../config/API";

function UserPaymentProcessing() {
  const navigate = useNavigate();

  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user"));

  // Data received from previous page
  const razorpay = location.state?.razorpay || {};

  const booking = location.state?.booking || {};

  const [loading, setLoading] = useState(false);

  const [paymentStatus, setPaymentStatus] = useState("PENDING");

  const [statusMessage, setStatusMessage] = useState("Waiting for Payment...");

  // 7 Minutes
  const [seconds, setSeconds] = useState(420);

  const timerRef = useRef(null);

  // -------------------------------
  // Start Countdown
  // -------------------------------
  useEffect(() => {
    timerRef.current = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);

          setPaymentStatus("EXPIRED");

          setStatusMessage("Payment Session Expired");

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, []);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      // Already loaded
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");

      script.src = "https://checkout.razorpay.com/v1/checkout.js";

      script.onload = () => {
        console.log("Razorpay SDK loaded successfully");
        resolve(true);
      };

      script.onerror = () => {
        console.error("Failed to load Razorpay SDK");
        resolve(false);
      };

      document.body.appendChild(script);
    });
  };

  // -------------------------------
  // Automatically Open Razorpay
  // -------------------------------
  useEffect(() => {
    if (!razorpay.orderId) {
      navigate(-1);

      return;
    }

    // Wait one second before opening checkout
    const timer = setTimeout(() => {
      openRazorpay();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // -------------------------------
  // Format Timer
  // -------------------------------
  const formatTime = () => {
    const min = Math.floor(seconds / 60);

    const sec = seconds % 60;

    return `${min}:${sec.toString().padStart(2, "0")}`;
  };
  const verifyPayment = async (response) => {
    try {
      setLoading(true);

      const payload = {
        registerId: booking.registerId,

        bedId: booking.bedId,

        paymentType: booking.paymentType,

        stayingDays: booking.stayingDays,

        amount: booking.amount,

        advanceAmount: booking.advanceAmount,

        totalAmount: booking.totalAmount,

        paymentMode: "RAZORPAY",

        paymentStatus: "SUCCESS",

        createdBy: booking.createdBy,

        razorpayOrderId: response.razorpay_order_id,

        razorpayPaymentId: response.razorpay_payment_id,

        razorpaySignature: response.razorpay_signature,
      };

      const res = await axios.post(`${API.V2}/payment/verify`, payload, {
        headers: {
          Authorization: `Bearer ${user?.jwtToken}`,
        },
      });

      if (res.data.statusCode === 200) {
        clearInterval(timerRef.current);

        setPaymentStatus("SUCCESS");

        setStatusMessage("Payment Successful");

        setTimeout(() => {
          navigate("/paymentSuccess");
        }, 2000);
      } else {
        setPaymentStatus("FAILED");

        setStatusMessage(res.data.message);
      }
    } catch (e) {
      console.log(e);

      setPaymentStatus("FAILED");

      setStatusMessage("Payment Verification Failed");
    } finally {
      setLoading(false);
    }
  };

  const retryPayment = () => {
    if (paymentStatus === "EXPIRED") {
      alert("Payment Session Expired.");

      navigate(-1);

      return;
    }

    openRazorpay();
  };
  // -----------------------------------------
  // Open Razorpay Checkout
  // -----------------------------------------

  const openRazorpay = async () => {
    // Load Razorpay SDK
    const isLoaded = await loadRazorpayScript();

    if (!isLoaded) {
      alert(
        "Unable to load Razorpay SDK. Please check your internet connection.",
      );
      return;
    }

    if (!window.Razorpay) {
      alert("Razorpay SDK is not available.");
      return;
    }

    if (!razorpay.orderId) {
      alert("Razorpay Order ID is missing.");
      return;
    }

    if (!razorpay.key) {
      alert("Razorpay Key is missing.");
      return;
    }

    console.log("Razorpay Data:", razorpay);

    const options = {
      key: razorpay.key,

      amount: razorpay.amount,

      currency: razorpay.currency || "INR",

      order_id: razorpay.orderId,

      name: "SVK PG",

      description: "PG Room Booking Payment",

      image: "/logo.png",

      prefill: {
        name: booking.userName || "",
        email: booking.emailId || "",
        contact: booking.mobileNumber ? String(booking.mobileNumber) : "",
      },

      theme: {
        color: "#2563eb",
      },

      handler: function (response) {
        console.log("Razorpay Payment Response:", response);

        verifyPayment(response);
      },

      modal: {
        ondismiss: function () {
          console.log("Razorpay checkout closed");

          setPaymentStatus("CANCELLED");

          setStatusMessage("Payment Cancelled By User");
        },
      },
    };

    try {
      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (response) {
        console.error("Payment Failed:", response.error);

        setPaymentStatus("FAILED");

        setStatusMessage(response.error?.description || "Payment Failed");
      });

      rzp.open();
    } catch (error) {
      console.error("Razorpay Checkout Error:", error);

      setPaymentStatus("FAILED");

      setStatusMessage("Unable to open Razorpay checkout.");
    }
  };
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Complete Your Payment</h2>

        {/* Status */}
        <div style={styles.statusBox}>
          <span
            style={{
              ...styles.statusBadge,

              background:
                paymentStatus === "SUCCESS"
                  ? "#dcfce7"
                  : paymentStatus === "FAILED"
                    ? "#fee2e2"
                    : paymentStatus === "EXPIRED"
                      ? "#fef3c7"
                      : "#dbeafe",

              color:
                paymentStatus === "SUCCESS"
                  ? "#15803d"
                  : paymentStatus === "FAILED"
                    ? "#b91c1c"
                    : paymentStatus === "EXPIRED"
                      ? "#b45309"
                      : "#1d4ed8",
            }}
          >
            {paymentStatus}
          </span>

          <p style={styles.statusText}>{statusMessage}</p>
        </div>

        {/* Timer */}

        {paymentStatus === "PENDING" && (
          <div style={styles.timerBox}>
            <div style={styles.timerTitle}>Payment Session Expires In</div>

            <div style={styles.timer}>{formatTime()}</div>
          </div>
        )}

        {/* Booking Details */}

        <div style={styles.infoCard}>
          <div style={styles.row}>
            <span>Register Id</span>
            <strong>{booking.registerId}</strong>
          </div>

          <div style={styles.row}>
            <span>Bed Id</span>
            <strong>{booking.bedId}</strong>
          </div>

          <div style={styles.row}>
            <span>Payment Type</span>
            <strong>{booking.paymentType}</strong>
          </div>

          <div style={styles.row}>
            <span>Staying Days</span>
            <strong>
              {booking.stayingDays == null ? "-" : booking.stayingDays}
            </strong>
          </div>

          <div style={styles.row}>
            <span>Room Amount</span>
            <strong>₹ {booking.amount}</strong>
          </div>

          <div style={styles.row}>
            <span>Advance Amount</span>
            <strong>₹ {booking.advanceAmount}</strong>
          </div>

          <div style={styles.row}>
            <span>Total Amount</span>

            <strong
              style={{
                color: "#16a34a",
                fontSize: 22,
                fontWeight: "700",
              }}
            >
              ₹ {booking.totalAmount}
            </strong>
          </div>
        </div>

        {/* Razorpay Order */}

        <div style={styles.infoCard}>
          <div style={styles.row}>
            <span>Order Id</span>

            <strong
              style={{
                fontSize: "13px",
                color: "#2563eb",
              }}
            >
              {razorpay.orderId}
            </strong>
          </div>

          <div style={styles.row}>
            <span>Currency</span>

            <strong>{razorpay.currency}</strong>
          </div>
        </div>

        {/* Loading */}

        {loading && (
          <div style={styles.loadingBox}>
            <div style={styles.loadingText}>Verifying Payment...</div>
          </div>
        )}

        {/* Buttons */}

        {paymentStatus !== "SUCCESS" && paymentStatus !== "EXPIRED" && (
          // <button style={styles.payButton} onClick={openRazorpay}>
          //   Pay Now
          // </button>
          <button
            style={styles.payButton}
            onClick={() => {
              navigate("/paymentMethod", {
                state: {
                  razorpay: razorpay,
                  booking: booking,
                },
              });
            }}
          >
            Pay Now
          </button>
        )}

        {paymentStatus === "FAILED" && (
          <button style={styles.retryButton} onClick={retryPayment}>
            Retry Payment
          </button>
        )}

        {paymentStatus === "EXPIRED" && (
          <button style={styles.retryButton} onClick={() => navigate(-1)}>
            Create New Order
          </button>
        )}

        <button style={styles.cancelButton} onClick={() => navigate(-1)}>
          Cancel
        </button>

        {/* Success */}

        {paymentStatus === "SUCCESS" && (
          <div style={styles.successBox}>
            <div style={styles.successTitle}>Payment Successful</div>

            <div style={styles.successText}>Redirecting...</div>
          </div>
        )}

        {/* Failed */}

        {paymentStatus === "FAILED" && (
          <div style={styles.failedBox}>
            <div style={styles.failedTitle}>Payment Failed</div>

            <div style={styles.failedText}>Please try again.</div>
          </div>
        )}
      </div>
    </div>
  );
}
export default UserPaymentProcessing;
const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#eef4ff,#dbeafe,#f8fafc)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
    fontFamily: "'Segoe UI', sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "650px",
    background: "#ffffff",
    borderRadius: "22px",
    padding: "35px",
    boxShadow: "0 20px 45px rgba(0,0,0,.15)",
  },

  title: {
    textAlign: "center",
    color: "#1e3a8a",
    fontSize: "32px",
    fontWeight: "700",
    marginBottom: "25px",
  },

  statusBox: {
    textAlign: "center",
    marginBottom: "25px",
  },

  statusBadge: {
    display: "inline-block",
    padding: "8px 22px",
    borderRadius: "30px",
    fontWeight: "700",
    fontSize: "14px",
    marginBottom: "10px",
  },

  statusText: {
    margin: 0,
    fontSize: "16px",
    color: "#475569",
    fontWeight: "600",
  },

  timerBox: {
    background: "#fff7ed",
    border: "2px solid #fdba74",
    borderRadius: "15px",
    padding: "18px",
    textAlign: "center",
    marginBottom: "25px",
  },

  timerTitle: {
    color: "#9a3412",
    fontWeight: "700",
    marginBottom: "8px",
    fontSize: "15px",
  },

  timer: {
    fontSize: "40px",
    fontWeight: "800",
    color: "#dc2626",
  },

  infoCard: {
    background: "#f8fafc",
    borderRadius: "15px",
    padding: "20px",
    border: "1px solid #e2e8f0",
    marginBottom: "25px",
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 0",
    borderBottom: "1px dashed #cbd5e1",
    fontSize: "15px",
  },

  loadingBox: {
    textAlign: "center",
    marginBottom: "20px",
  },

  loadingText: {
    color: "#2563eb",
    fontWeight: "700",
    fontSize: "18px",
  },

  payButton: {
    width: "100%",
    padding: "15px",
    background: "#2563eb",
    color: "#ffffff",
    border: "none",
    borderRadius: "12px",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "17px",
    marginBottom: "15px",
    transition: "0.3s",
  },

  retryButton: {
    width: "100%",
    padding: "15px",
    background: "#f59e0b",
    color: "#ffffff",
    border: "none",
    borderRadius: "12px",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "17px",
    marginBottom: "15px",
  },

  cancelButton: {
    width: "100%",
    padding: "15px",
    background: "#ef4444",
    color: "#ffffff",
    border: "none",
    borderRadius: "12px",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "17px",
  },

  successBox: {
    background: "#dcfce7",
    border: "2px solid #22c55e",
    borderRadius: "15px",
    padding: "20px",
    textAlign: "center",
    marginTop: "25px",
  },

  successTitle: {
    color: "#15803d",
    fontWeight: "700",
    fontSize: "26px",
    marginBottom: "10px",
  },

  successText: {
    color: "#166534",
    fontSize: "16px",
    fontWeight: "600",
  },

  failedBox: {
    background: "#fee2e2",
    border: "2px solid #ef4444",
    borderRadius: "15px",
    padding: "20px",
    textAlign: "center",
    marginTop: "25px",
  },

  failedTitle: {
    color: "#b91c1c",
    fontWeight: "700",
    fontSize: "24px",
    marginBottom: "8px",
  },

  failedText: {
    color: "#7f1d1d",
    fontSize: "15px",
    fontWeight: "600",
  },
};
